/* eslint-disable no-open-modules-imports */

import type { FeatureGroup } from 'feature/feature-helpers';
import { SECTION } from 'feature/feature-helpers';
import { PostAnywayFilterFeature } from 'feature/moddash/post-anyway-filter';
import { t } from 'util/stdtypes';

export const moderationDashFeatures: FeatureGroup[] = [SECTION(t('Filters'), [PostAnywayFilterFeature])];

export const moderationDashDefaultConfig = {
    post_anyway_filter: true,
};
